import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CarbonTrailModule } from './carbon-trail.module';

platformBrowserDynamic().bootstrapModule(CarbonTrailModule)
    .catch(err => console.error(err));
